export default __webpack_public_path__ + "static/stairs_w.d3af5af7779374da7995e0fb7c0184ee.png";